import { Changes } from './types';

const afterCellChanged = (changes: Changes) => changes;

export default afterCellChanged;
